import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_JOB_BOARD_API_URL;

/**
 * Common auth header helper
 */
const authHeader = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});


export const getEmployerDashboardStats = async (token, companyId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/dashboard/stats`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          companyId, // 🔴 THIS WAS MISSING
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to load employer dashboard stats", error);
    throw error;
  }
};



export const getEmployerRecentJobs = async (token, companyId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/dashboard/recent-jobs`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          companyId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to load recent jobs", error);
    throw error;
  }
};



export const getEmployerLatestApplications = async (token, companyId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/dashboard/latest-applications`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          companyId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to load latest applications", error);
    throw error;
  }
};



export const searchEmployerDashboard = async (token, query) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/employer/dashboard/search`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          q: query,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Dashboard search failed", error);
    throw error;
  }
};


export const getEmployerDashboardContext = async (token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/employer/dashboard/context`,
      authHeader(token)
    );
    return response.data;
  } catch (error) {
    console.error("Failed to load employer dashboard context", error);
    throw error;
  }
};


